import React from "react";
import { Routes, Route } from "react-router-dom";
import { LegacyOpportunityRedirect } from "@/pages/Opportunities/LegacyOpportunityRedirect";
import { StudiesList } from "@/pages/Studies/StudiesList";

export const StudiesRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="*" element={<LegacyOpportunityRedirect study />} />
        </Routes>
    );
};

export { StudiesList };
